class ReadMore extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.els.trigger?.elements.forEach(triggerEl => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })
  }

  handleTrigger (event) {
    this.els.content.elements.forEach(contentEl => {
      contentEl.setAttribute(
        'aria-hidden',
        contentEl.dataset.contentType !== event.target.dataset.triggerType,
      )
    })
  }
}

if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore)
}
